import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import './AdminLogin.css';

const API_URL = process.env.REACT_APP_API_URL;

function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!email.trim() || !password.trim()) {
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_URL}/api/auth/login`, {
        email: email.trim(),
        password,
      });
      login(response.data.token, response.data.user);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="background" />
      <div className="light-rays">
        <div className="wave wave-top"></div>
        <div className="wave wave-middle"></div>
        <div className="wave wave-bottom"></div>
      </div>

      <div className="bubble-sphere bubble-left">
        <div className="sphere-inner">
          <img src="/heart.png" alt="Heart" className="bubble-img" />
        </div>
      </div>
      <div className="bubble-sphere bubble-right-top">
        <div className="sphere-inner">
          <img src="/skull.png" alt="Skull" className="bubble-img" />
        </div>
      </div>
      <div className="bubble-sphere bubble-right-bottom">
        <div className="sphere-inner">
          <img src="/cell.png" alt="Cell" className="bubble-img" />
        </div>
      </div>
      <div className="bubble-sphere bubble-left-bottom">
        <div className="sphere-inner">
          <img src="/brain.png" alt="Brain" className="bubble-img" />
        </div>
      </div>

      <div className="admin-login-content">
        <img src="/DarkLogo.png" alt="METATIP Logo" className="admin-login-logo" />

        <div className="admin-login-card">
          <form onSubmit={handleSubmit}>
            <h2>Admin Login</h2>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              disabled={loading}
            />
            <div className="admin-password-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                disabled={loading}
              />
              <button
                type="button"
                className="admin-password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                <img
                  src={showPassword
                    ? "https://cdn-icons-png.flaticon.com/512/875/875643.png"
                    : "https://cdn-icons-png.flaticon.com/512/2767/2767146.png"
                  }
                  alt={showPassword ? 'Hide password' : 'Show password'}
                  className="admin-password-icon"
                />
              </button>
            </div>
            {error && <div className="admin-error-message">{error}</div>}
            <button type="submit" disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;